import React from 'react';
import { Box, Typography } from '@mui/material';

export default function JsonPayloadFallback({ payload }) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        No dedicated panel for this issue type. Showing payload JSON.
      </Typography>
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 1.5,
          bgcolor: '#f8fafc',
          borderRadius: 1,
          overflow: 'auto',
          fontSize: '0.75rem',
        }}
      >
        {JSON.stringify(payload ?? {}, null, 2)}
      </Box>
    </Box>
  );
}
